"use strict";
module.exports = [
    {
        "id": "0x09305998a531fade369ebe30adf868c96a34e813",
        "name": "dcl://pm_dreamverse_eminence",
        "symbol": "DCLPMDRMVRSMNNC",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x0b1c6c75d511fae05e7dc696f4cf14129a9c43c9",
        "name": "dcl://ml_liondance",
        "symbol": "DCLLMLNDNC",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x102daabd1e9d294d4436ec4c521dce7b1f15499e",
        "name": "dcl://dc_niftyblocksmith",
        "symbol": "DCLDCNFTYBLCKSMTH",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x1a57f6afc902d25792c53b8f19b7e17ef84222d5",
        "name": "dcl://meme_dontbuythis",
        "symbol": "DCLMMDNTBYTHS",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x1e1d4e6262787c8a8783a37fee698bd42aa42bec",
        "name": "dcl://dappcraft_moonminer",
        "symbol": "DCLDPPCRFTMNMNR",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x201c3af8c471e5842428b74d1e7c0249adda2a92",
        "name": "dcl://stay_safe",
        "symbol": "DCLSTYSF",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x24d538a6265b006d4b53c45ba91af5ef60dca6cb",
        "name": "dcl://cybermike_cybersoldier_set",
        "symbol": "DCLCYBMKCYBRSLDRST",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x30d3387ff3de2a21bef7032f82d00ff7739e403c",
        "name": "dcl://mf_sammichgamer",
        "symbol": "DCLMFSMMCHGMR",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x3163d2cfee3183f9874e2869942cc62649eeb004",
        "name": "dcl://dcg_collection",
        "symbol": "DCLDCGCLLCTN",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x32b7495895264ac9d0b12d32afd435453458b1c6",
        "name": "dcl://community_contest",
        "symbol": "DCLCMMNTCNTST",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x34ed0aa248f60f54dd32fbc9883d6137a491f4f3",
        "name": "dcl://wonderzone_meteorchaser",
        "symbol": "DCLWNDRZNMTRCHSR",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x480a0f4e360e8964e68858dd231c2922f1df45ef",
        "name": "dcl://tech_tribal_marc0matic",
        "symbol": "DCLTCHTRBLMRC0MTC",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x4c290f486bae507719c562b6b524bdb71a2570c9",
        "name": "dcl://atari_launch",
        "symbol": "DCLTR",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x54266bcf2ffa841af934f003d144957d5934f3ab",
        "name": "dcl://ethermon_wearables",
        "symbol": "DCLETHRMNWRBL",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x574f64ac2e7215cba9752b85fc73030f35166bc0",
        "name": "dcl://dgtble_headspace",
        "symbol": "DCLDGTBLHDSPC",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x5cf39e64392c615fd8086838883958752a11b486",
        "name": "dcl://digital_alchemy",
        "symbol": "DCLDGTLLCHMY",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x5df4602e7f38a91ea7724fc167f0c67f61604b1e",
        "name": "dcl://wz_wonderbot",
        "symbol": "DCLWZWNDRBT",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x60d8271c501501c4b8cd9ed5343ac59d1b79d993",
        "name": "dcl://ml_pekingopera",
        "symbol": "DCLMLPKNGPR",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x68e139552c4077ce5c9ab929c7e18ca721ffff00",
        "name": "dcl://rac_basics",
        "symbol": "DCLRCBSCS",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x6a99abebb48819d2abe92c5e4dc4f48dc09a3ee8",
        "name": "dcl://moonshot_2020",
        "symbol": "DCLMNSHT2020",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x6b47e7066c7db71aa04a1d5872496fe05c4c331f",
        "name": "dcl://rtfkt_x_atari",
        "symbol": "DCLRTFTKTI",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x7038e9d2c6f5f84469a84cf9bc5f4909bb6ac5e0",
        "name": "dcl://dg_fall_2020",
        "symbol": "DCLDGFLL2020",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x75a3752579dc2d63ca229eebbe3537fbabf85a12",
        "name": "dcl://pm_outtathisworld",
        "symbol": "DCLPMTTTHSWRLD",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0x90958d4531258ca11d18396d4174a007edbc2b42",
        "name": "dcl://china_flying",
        "symbol": "DCLCHNFLYNG",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xa8ee490e4c4da48cc1653502c1a77479d4d818de",
        "name": "dcl://binance_us_collection",
        "symbol": "DCLBNNCSCLLCTN",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xb5d14052d1e2bce2a2d7459d0379256e632b855d",
        "name": "dcl://sugarclub_yumi",
        "symbol": "DCLSGRCLBYM",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xb96697fa4a3361ba35b774a42c58daccaad1b8e1",
        "name": "dcl://wonderzone_steampunk",
        "symbol": "DCLWNDRZNSTMPNK",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xbf53c33235cbfc22cef5a61a83484b86342679c5",
        "name": "dcl://dg_summer_2020",
        "symbol": "DCLDGSMMR2020",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xc04528c14c8ffd84c7c1fb6719b4a89853035cdd",
        "name": "dcl://exclusive_masks",
        "symbol": "DCLEXCLSVMSKS",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xc1f4b0eea2bd6690930e6c66efd3e197d620b9c2",
        "name": "dcl://halloween_2019",
        "symbol": "DCLHLWN2019",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xc3af02c0fd486c8e9da5788b915d6fff3f049866",
        "name": "dcl://xmas_2019",
        "symbol": "DCLXMAS2019",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xc3ca6c364b854fd0a653a43f8344f8c22ddfdd26",
        "name": "dcl://cz_mercenary_mtz",
        "symbol": "DCLCZMRCNRYMTZ",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xc82a864a94db3550bc71fcb4ce07228bcec21f1a",
        "name": "dcl://winklevoss_capital",
        "symbol": "DCLWNKLVSSCPTL",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xd35147be6401dcb20811f2104c33de8e97ed6818",
        "name": "dcl://dcl_launch",
        "symbol": "DCLLNCH",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xdd9c7bc159dacb19c9f6b9d7e23948c87aa2397f",
        "name": "dcl://xmash_up_2020",
        "symbol": "DCLXMSHP2020",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xe1ecb4e5130f493551c7d6df96ad19e5b431a0a9",
        "name": "dcl://3lau_basics",
        "symbol": "DCL3LBSCS",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xe7a64f6a239ed7f5bf18caa1ce2920d0c1278129",
        "name": "dcl://dc_meta",
        "symbol": "DCLDCMT",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xecf073f91101ce5628669c487aee8f5822a101b1",
        "name": "dcl://xmas_2020",
        "symbol": "DCLXMAS2020",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xf64dc33a192e056bb5f0e5049356a0498b502d50",
        "name": "dcl://mch_collection",
        "symbol": "DCLMCHCLLTN",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xfeb52cbf71b9adac957c6f948a6cf9980ac8c907",
        "name": "dcl://halloween_2020",
        "symbol": "DCLHLWN2020",
        "isApproved": null,
        "isCompleted": true
    },
    {
        "id": "0xffc5043d9a00865d089d5eefa5b3d1625aec6763",
        "name": "dcl://release_the_kraken",
        "symbol": "DCLRLSTHKRKN",
        "isApproved": null,
        "isCompleted": true
    }
];
//# sourceMappingURL=collections-v1.js.map